import * as React from "react"
import { Line } from "@reactchartjs/react-chart.js"
import { useSelector } from "react-redux"
import { AppState } from "../../../store/types"

export interface ILineChartProps {
  displayBig: boolean
}

const Chart = (props: ILineChartProps) => {
  const { displayBig } = props
  const { chartData } = useSelector(
    (state: AppState) => state.devDocs
  )

  if (chartData.length === 0) {
    return <></>
  }

  const maxPercentage = Math.max(...chartData.map(x => x.percentage))
  const minPercentage = Math.min(...chartData.map(x => x.percentage))

  const data = {
    labels: chartData.map(x => x.dateTime),
    datasets: [
      {
        borderWidth: displayBig ? 2 : 7,
        label: displayBig ? "Estimated Relative Availability" : "",
        data: chartData.map(x => ((x.percentage - minPercentage) / (maxPercentage - minPercentage))* 100),
        fill: false,
        // backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#EC1300",
        pointRadius: 0,
      },
    ],
  }

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            display: displayBig,
          },
          scaleLabel: {
            display: displayBig,
            labelString: "Est. Availability",
          },
        },
      ],
      xAxes: [
        {
          type: 'time',
          time: {
            displayFormats: {
              hour: 'HH:mm'
            }
          },
          ticks: {
            display: displayBig,
          },
          scaleLabel: {
            display: displayBig,
            labelString: "Time",
          },
        },
      ],
    },
    legend: {
      display: displayBig,
    },
  }

  return <Line type="line" data={data} options={options} />
}

export default Chart
